var $ = require('../internals/export');
var assign = require('../internals/object-assign');

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.object.assign.js
// module id = 121
// module chunks = 0 1 2 7 8 9 10 11 12 21 23 24 25 26 33 37